var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-form-item',{staticClass:"n-textarea",attrs:{"title":_vm.title}},[(!_vm.text)?_c('ckeditor',{attrs:{"value":_vm.value,"editor":_vm.editor,"config":_vm.config},on:{"input":_vm.input,"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }